import * as runtime from '@/api/runtime'

export interface BatchReturnInfoExtractApi {
  data: FormData
}

/**
 * DAMファイルDL
 */
export class BatchReturnInfoExtractApi extends runtime.BaseAPI {
  async return(returnDate: string): Promise<number> {
    const queryParameters: runtime.HTTPQuery = { return_date: returnDate }
    const response = await this.requestGet(
      `/batch/return/return-info-extract`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
